import React from 'react'

const Designer = () => {
  return (
    <div>Designer</div>
  )
}

export default Designer